import { STEP_COLUMNS } from "./step-column";
import DataTable from "../../../components/common/data-table/data-table";
import { useNavigate } from "react-router-dom";
import StepForm from "./step-form";

interface StepProps {}

const Step: React.FC<StepProps> = () => {
  const navigate = useNavigate();

  return (
    <div>
      <DataTable
        tableName="Step"
        parentTableName="Management"
        deleteTitle="Step"
        mainCol="title"
        getAllLink="/api/admin/award-steps/" //TODO add "api" to base rout
        getItemLink="/api/admin/award-steps" //TODO add "api" to base rout
        hasEdit={true}
        hasCreate={true}
        hasDelete={true}
        updateItemLink="/api/admin/award-steps" //TODO add "api" to base rout
        createItemLink="/api/admin/award-steps" //TODO add "api" to base rout
        deleteRowLink="/api/admin/award-steps" //TODO add "api" to base rout
        tableCols={STEP_COLUMNS}
        FormContent={StepForm}
        handleEditRow={(id) => {
          navigate(`/management/steps/${id}/edit`);
        }}
        formSubmitMapper={(data: any) => {
          const formData = new FormData();
          formData.append("translations[0][locale]", "en");
          formData.append("translations[0][title]", data.title);
          formData.append("translations[1][locale]", "ar");
          formData.append("translations[1][title]", data.titleAr);
          if (!data?.id) formData.append("stepAward", data.stepAward);
          formData.append("published", data.published);
          if (!data?.id || data.coverImage) {
            formData.append("coverImage", data.coverImage);
          }
          return formData;
        }}
      />
    </div>
  );
};

export default Step;
